import React, { useContext } from 'react';
import { UtilsBlock, Title4, Carousel, Image } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

import Classes from './SellReasons.module.scss';

const REASON_KEYS = ['reason1', 'reason2', 'reason3', 'reason4'] as const;

const SellReasons = () => {
  const { t } = useI18nContext();
  const {
    links: { imageSources },
  } = useContext(EnvironmentContext);

  return (
    <>
      <UtilsBlock mb={['xxs', 'l', null]} className={Classes.root}>
        <Title4 utilities={['marginBottomXxs']} className="Section-title">
          <span className="Title-highlight">{t('sell.page.reasons.titleHighlight')}</span>
          <span>{t('sell.page.reasons.title')}</span>
        </Title4>
        <UtilsBlock color="text-secondary">{t('sell.page.reasons.subtitle')}</UtilsBlock>
      </UtilsBlock>
      <Carousel title="" className="reasonCarousel">
        {REASON_KEYS.map((key) => (
          <article key={key} className={Classes.reasonCard}>
            <Image
              className={Classes.reasonImage}
              src={imageSources[key]}
              alt="image"
              fetchPriority="auto"
              // @ts-expect-error -- DS issue
              aspectRatio=""
            />
            <UtilsBlock textStyle={['body-small-strong', null, 'body-base-strong']} mb="xxs">
              {t(`sell.page.reasons.${key}.title`)}
            </UtilsBlock>
            <UtilsBlock color="text-secondary">{t(`sell.page.reasons.${key}.body`)}</UtilsBlock>
          </article>
        ))}
      </Carousel>
    </>
  );
};

export default SellReasons;
